
import axios from 'axios';

export const ApiHooks = () => {

    //EndPoint Call For the Content
    const getStoreInfo = async ( data, endpoint) => {
        let url = null;
        let uberall = "";
        try {
            switch (endpoint) {
                case "store_uberall":
                    url = `${process.env.GATSBY_UBERALL_LINK}/${process.env.GATSBY_UBERALL_KEY_ID}/locations/${data}?fieldMask=primary&fieldMask=phone&fieldMask=identifier&fieldMask=zip&fieldMask=name&fieldMask=descriptionLong&fieldMask=address&fieldMask=addressExtra&fieldMask=streetAndNumber&fieldMask=openingHours&fieldMask=nextOpen&fieldMask=website&fieldMask=timezone&fieldMask=lat&fieldMask=lng&fieldMask=city&fieldMask=province&fieldMask=country&fieldMask=openNow&fieldMask=display_name&fieldMask=cic_store_id&fieldMask=alt_text_cic_serv_check_cashing&fieldMask=alt_text_cic_serv_money_orders&fieldMask=alt_text_cic_serv_sell_us_gift_cards&fieldMask=landmark&fieldMask=alt_text_cic_prod_title_small&fieldMask=alt_text_cic_prod_payday_small&fieldMask=cta_icon_primary&fieldMask=momentfeed-services&fieldMask=featured&fieldMask=alt_text_cic_serv_bill_pay&fieldMask=alt_text_cic_serv_us_money_card_default&fieldMask=brand_type&fieldMask=page_title&fieldMask=alt_text_cic_prod_flex_small&fieldMask=twitter_handle&fieldMask=yext_id&fieldMask=meta_keywords&fieldMask=sublocality&fieldMask=meta_desc&fieldMask=alt_text_cic_serv_western_union&fieldMask=youtube_link&fieldMask=store_image&fieldMask=city_directory_copy&fieldMask=brand_for_foldering&fieldMask=alt_text_cic_prod_installment_small&fieldMask=alt_text_starburst_check&fieldMask=googlePlaceId&fieldMask=reviews`;
                    uberall = "UBERALL";
                    break;
                case "store_locator_uberall":
                    url = `${process.env.GATSBY_UBERALL_SL}/${process.env.GATSBY_UBERALL_KEY_ID}/locations?${data}&radius=40000&fieldMask=primary&fieldMask=identifier&fieldMask=zip&fieldMask=name&fieldMask=descriptionLong&fieldMask=address&fieldMask=addressExtra&fieldMask=streetAndNumber&fieldMask=openingHours&fieldMask=nextOpen&fieldMask=website&fieldMask=timezone&fieldMask=lat&fieldMask=lng&fieldMask=city&fieldMask=province&fieldMask=country&fieldMask=openNow&fieldMask=sublocality&fieldMask=store_image&fieldMask=phone&fieldMask=googlePlaceId&fieldMask=reviews&fieldMask=status`;
                    uberall = "UBERALL";
                    break;        
                case "store":
                    url = `${process.env.GATSBY_MF_LOCATIONS}${data}`;
                    break;
                case "store_content":
                    url = `${process.env.GATSBY_MF_CONTENT}${data}/blueprints/localPage?=`;
                    break;
                case "store_locator":
                    url = `${process.env.GATSBY_MF_STORE_LOCATOR}${data}&radius=30&pageSize=3`;
                    break;
                case "testimonials":
                    url = `${process.env.GATSBY_MF_TESTIMONIALS}${process.env.GATSBY_MF_TOKEN}&corporate_id=${data}&star_rating=5&limit=3`;
                    break;
                default:
                    url = ``;
                    break;
            }
            const resp = await callMomentAPI(url, uberall);
            return resp; 
        } 
        catch (error) {
            return error
        }
    }
    const callMomentAPI = (url, uberall) => {
        let heads =  { "Authorization": process.env.GATSBY_API_KEY }
        if(uberall !== ""){
            heads = { "privateKey": process.env.GATSBY_UBERALL_API_KEY }
        }
        return new Promise((resolve, reject) => {
            axios.get(url, { headers: heads })
            .then(response => {
                resolve (response);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    } 
    //EndPoint for Central
    const storeLocatorAPI = (lat, lng) => {
        const apiUrl = "https://cacheckcashdev.wpengine.com/wp-content/themes/bb-theme-child/api/store-locator-ub-central.php";
        const data = { 
            'lat': lat,
            'lng': lng, 
        }
        return new Promise((resolve, reject) => {
            axios.post(apiUrl, data, { headers: { "Content-Type": "text/plain" } })
            .then(response => { 
                resolve (response);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    }
    const getCentralStore = async ( data, endpoint) => {
        let url = null;
        let data_info = "";
        try {
            switch (endpoint) {
                case "store_uberall":
                    url = `https://cacheckcashdev.wpengine.com/wp-content/themes/bb-theme-child/api/single-store-central.php`;
                    data_info= {
                        "StoreNumber": data
                    }
                    break;
                case "store_locator_uberall":
                    data_info = { 
                        'lat': data.lat,
                        'lng': data.lng, 
                    }
                    url = `https://cacheckcashdev.wpengine.com/wp-content/themes/bb-theme-child/api/store-locator-central.php`;
                    break;   
                default:
                    url = ``;
                    break;
            }
            const resp = await callCentralAPI(url, data_info);
            return resp; 
        } 
        catch (error) {
            return error
        }
    }
    const callCentralAPI = (url, data) => { 
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: { "Content-Type": "text/plain" } })
                .then(response => {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    };
    
    //EndPoint Call For the Loans
    const getStoreLoans = async ( data, endpoint) => {
        let url = null
        try {
            switch (endpoint) {
                case "loans":
                    url = `${process.env.GATSBY_LOANS_API}`;
                    break;
                default:
                    url = ``;
                    break;
            }
            const resp = await callLoansAPI(data, url);
            return resp; 
        } 
        catch (error) {
            return error
        }
    }
    const callLoansAPI = ( data, url  ) => {
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: { "Content-Type": "text/plain" } })
            .then(response => {
                resolve (response);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    }

    //Newsletter Endpoint
    
    const saveNewsletter = async ( mail,number, type) => {
        let url = `${process.env.GATSBY_NEWSLETTER}`;
        try {
            switch (type) {
                case "email":
                    number = "-";
                    break;
                default:
                    mail = "-";
                    break;
            }
            const resp = await callNewsletter( mail,number, type, url);
            return resp; 
        } 
        catch (error) {
            return error
        }
    }
    const callNewsletter = (  mail,number, type, url  ) => {
        const data = {
            'mail': mail,
            'number': number,
            'section': type,
        }
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: { "Content-Type": "text/plain" } })
            .then(response => {
                resolve (response);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    } 

    //Google Maps
    const getPlaceByZipCode = (zipCode) => { 
        const components = 'country:US';
        let url = "https://maps.googleapis.com/maps/api/geocode/json";
        url =  url + "?address=" + zipCode + " &key=" + process.env.GATSBY_GOOGLE_API_KEY+ "&components="+components;
        return new Promise((resolve, reject) => {
            axios.get(url, { headers: { "Content-Type": "application/json", } })
            .then(response => {
                resolve (response);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    }

    const callKickBox = (  mail ) => {
        let url = `${process.env.GATSBY_KICKBOX}`;
        const data = {
            'email': mail
        }
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: { "Content-Type": "text/plain" } })
            .then(response => {
                resolve (response);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    } 
    const sendMessage = (  data ) => {
        let url = `${process.env.GATSBY_MESSAGE}`;
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: { "Content-Type": "text/plain" } })
            .then(response => {
                resolve (response);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    } 
    const verifyZip = (zipCode) => { 
        
        const encodedXml =  ('<CityStateLookupRequest USERID="033CHECK5837"><ZipCode ID="0"><Zip5>'+zipCode+'</Zip5></ZipCode></CityStateLookupRequest>');
        const url = 'https://production.shippingapis.com/ShippingAPITest.dll?API=CityStateLookup&XML='+encodedXml;
        return new Promise((resolve, reject) => {
            axios.get(url, { headers: { "Content-Type": "application/json", } })
            .then(response => {
                resolve (response);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    }

    const saveShortForm = (data) => {
        let url = `https://cacheckcashdev.wpengine.com/wp-content/themes/bb-theme-child/api/california-check-cashing.php`;
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: { "Content-Type": "text/plain" } })
                .then(response => {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
    const savePhoneForm = (data) => {
        let url = `https://cacheckcashdev.wpengine.com/wp-content/themes/bb-theme-child/api/dialer-consent.php`;
    //    return Promise.resolve(); // mock success
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: { "Content-Type": "text/plain" } })
                .then(response => {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
    const searchZipUberall = (data) => {
        let url = `https://cacheckcashdev.wpengine.com/wp-content/themes/bb-theme-child/api/get-stores-by-zip-central.php`;
        return new Promise((resolve, reject) => {
            axios.post(url, data, { headers: { "Content-Type": "text/plain" } })
                .then(response => {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
    return {
        getStoreInfo,
        getStoreLoans,
        saveNewsletter,
        getPlaceByZipCode,
        callKickBox,
        sendMessage,
        verifyZip,
        saveShortForm,
        savePhoneForm,
        getCentralStore,
        storeLocatorAPI,
        searchZipUberall
    }
}
//Changes